module.exports = {
  "zones": {
    "Atlantic/Azores": ["z", {
      "wallclock": 733280400000,
      "format": "-01/+00",
      "abbrev": "+00",
      "offset": -3600000,
      "posix": 733280400000,
      "save": 3600000,
      "rules": "EU"
    }, {
      "wallclock": 717559200000,
      "format": "WE%sT",
      "abbrev": "WET",
      "offset": 0,
      "posix": 717559200000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": 433303200000,
      "format": "-01/+00",
      "abbrev": "-01",
      "offset": -3600000,
      "posix": 433303200000,
      "save": 0,
      "rules": "W-Eur"
    }, {
      "wallclock": -118274400000,
      "format": "-01/+00",
      "abbrev": "-01",
      "offset": -3600000,
      "posix": -118267200000,
      "save": 0,
      "rules": "Port"
    }, {
      "wallclock": -768441600000,
      "format": "-02/-01",
      "abbrev": "-01",
      "offset": -7200000,
      "posix": -768441600000,
      "save": 3600000,
      "rules": "Port"
    }, {
      "wallclock": -779331600000,
      "format": "+00",
      "abbrev": "+00",
      "offset": -7200000,
      "posix": -779328000000,
      "save": 7200000,
      "rules": "Port"
    }, {
      "wallclock": -799891200000,
      "format": "-02/-01",
      "abbrev": "-01",
      "offset": -7200000,
      "posix": -799891200000,
      "save": 3600000,
      "rules": "Port"
    }, {
      "wallclock": -810781200000,
      "format": "+00",
      "abbrev": "+00",
      "offset": -7200000,
      "posix": -810777600000,
      "save": 7200000,
      "rules": "Port"
    }, {
      "wallclock": -831340800000,
      "format": "-02/-01",
      "abbrev": "-01",
      "offset": -7200000,
      "posix": -831340800000,
      "save": 3600000,
      "rules": "Port"
    }, {
      "wallclock": -842835600000,
      "format": "+00",
      "abbrev": "+00",
      "offset": -7200000,
      "posix": -842832000000,
      "save": 7200000,
      "rules": "Port"
    }, {
      "wallclock": -864000000000,
      "format": "-02/-01",
      "abbrev": "-01",
      "offset": -7200000,
      "posix": -864000000000,
      "save": 3600000,
      "rules": "Port"
    }, {
      "wallclock": -873680400000,
      "format": "+00",
      "abbrev": "+00",
      "offset": -7200000,
      "posix": -873676800000,
      "save": 7200000,
      "rules": "Port"
    }, {
      "wallclock": -1830383672000,
      "format": "-02/-01",
      "abbrev": "-02",
      "offset": -7200000,
      "posix": -1830376800000,
      "save": 0,
      "rules": "Port"
    }, {
      "wallclock": -2713910400000,
      "format": "HMT",
      "abbrev": "HMT",
      "offset": -6872000,
      "posix": -2713904240000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -6160000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "W-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Port": [{
      "from": 1983,
      "to": 1983,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1982,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1982,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1980,
      "to": 1980,
      "month": 2,
      "day": [0, -31],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1979,
      "month": 3,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 2,
      "day": [7, 27],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [7, 25],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1965,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1965,
      "month": 9,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1947,
      "to": 1949,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1949,
      "month": 9,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1946,
      "month": 3,
      "day": [6, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 9,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1945,
      "month": 2,
      "day": [6, 8],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1945,
      "month": 9,
      "day": [6, 24],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1945,
      "month": 7,
      "day": [6, 25],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1944,
      "to": 1945,
      "month": 3,
      "day": [6, 21],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 3,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 3,
      "day": [7, 25],
      "time": 1380,
      "clock": "wallclock",
      "save": 120,
      "letter": "M",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 7,
      "day": [7, 15],
      "time": 1440,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 7200000
    }, {
      "from": 1940,
      "to": 1941,
      "month": 9,
      "day": [7, 5],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1941,
      "to": 1941,
      "month": 3,
      "day": [7, 5],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1940,
      "to": 1940,
      "month": 1,
      "day": [7, 24],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 3,
      "day": [7, 15],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1939,
      "to": 1939,
      "month": 10,
      "day": [7, 18],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1934,
      "to": 1938,
      "month": 9,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1938,
      "to": 1938,
      "month": 2,
      "day": [7, 26],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1937,
      "to": 1937,
      "month": 3,
      "day": [7, 3],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1936,
      "to": 1936,
      "month": 3,
      "day": [7, 18],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1935,
      "to": 1935,
      "month": 2,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1934,
      "to": 1934,
      "month": 3,
      "day": [7, 7],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1931,
      "to": 1932,
      "month": 9,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1932,
      "to": 1932,
      "month": 3,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1931,
      "to": 1931,
      "month": 3,
      "day": [7, 18],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1926,
      "to": 1929,
      "month": 9,
      "day": [6, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1929,
      "to": 1929,
      "month": 3,
      "day": [7, 20],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1928,
      "to": 1928,
      "month": 3,
      "day": [7, 14],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1927,
      "to": 1927,
      "month": 3,
      "day": [7, 9],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1926,
      "to": 1926,
      "month": 3,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 3,
      "day": [7, 16],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1924,
      "to": 1924,
      "month": 9,
      "day": [7, 14],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1917,
      "to": 1921,
      "month": 9,
      "day": [7, 14],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1921,
      "to": 1921,
      "month": 1,
      "day": [7, 28],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1920,
      "to": 1920,
      "month": 1,
      "day": [7, 29],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 1,
      "day": [7, 28],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 2,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 1,
      "day": [7, 28],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 5,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 10,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};